<template>
  <div>
    <div class="form-group">
      <label for="ddlSound" v-if="showLabel">Sound</label>
      <v-select
        id="ddlSound"
        v-model="sound"
        @input="$emit('input', sound)"
        :options="sounds_for_drop_down"
        placeholder="Select.."></v-select>
    </div>
    <div v-if="show_preview">
      <div class="form-group">
        <label>Preview Sound</label>
          <a-player narrow :music="{
          title: sound.label,
          author: sound.label,
          url: '/upload/sounds/' + scoped_site_id + '/' + sound.label,
          pic: './static/images/sound_file_image.png'
        }"></a-player>
      </div>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import _ from 'lodash'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import VueAplayer from '../views/Sound/vue-aplayer'
import 'aplayer/dist/APlayer.min.css'

export default {
  props: {
    tag: {
      type: String,
      required: true
    },
    showLabel: {
      type: Boolean,
      default: true
    },
    value: {}
  },
  data: function () {
    return {
      sound: this.value
    }
  },
  components: { vSelect, 'a-player': VueAplayer },
  computed: {
    ...mapGetters({
      sounds: 'allSounds',
      scoped_site_id: 'scopedSiteId'
    }),
    sounds_for_drop_down: function () {
      let soundsForDropDown = []

      for (let i = 0; i < this.sounds.length; i++) {
        if (this.sounds[i].site_id === this.scoped_site_id &&
            this.sounds[i].tags.includes(this.tag)) {
          soundsForDropDown.push({
            value: this.sounds[i].sound_id,
            label: this.sounds[i].filename
          })
        }
      }

      return soundsForDropDown
    },
    show_preview: function () {
      return !_.isEmpty(this.sound)
    }
  },
  watch: {
    value (newValue, oldValue) {
      this.sound = newValue
    }
  },
  created () {
    this.$store.dispatch('getSounds')
  }
}
</script>
